export default {
  // 查询订单利润报表-列表
  getReportByOrder: {
    url: '/allPlatform/getReportByOrder',
    method: 'post',
    desc: '订单利润报表-列表'
  },
  // 查询订单明细利润报表-列表
  getReportByOrderItems: {
    url: '/allPlatform/getReportByOrderItems',
    method: 'post',
    desc: '订单利润报表-列表明细'
  },
  // 订单利润报表总计
  getOrderProfitSummary: {
    url: '/allPlatform/getReportByOrder/summary',
    method: 'post',
    desc: '订单利润报表-总计'
  },

  // 查询订单利润报表-仓库列表
  getWareHouseInfo: {
    url: '/allPlatform/getWareHouseInfo',
    method: 'post',
    desc: '订单利润报表-仓库列表'
  },
  // 查询订单利润报表-平台列表
  getPlatformInfo: {
    url: '/allPlatform/getPlatformInfo',
    method: 'post',
    desc: '订单利润报表-仓库列表'
  },

  // 月结利润报表-订单明细列表
  getMonthlyProfitOrderDetailList: {
    url: '/finance/profit/order/sku',
    method: 'post',
    desc: '月结利润报表-订单明细列表'
  },

  // 月结利润报表-订单明细总计
  getMonthlyProfitOrderDetailSummary: {
    url: '/finance/profit/order/sku/summary',
    method: 'post',
    desc: '月结利润报表-订单明细总计'
  },

  // 月结利润报表-订单列表
  getMonthlyProfitOrderList: {
    url: '/finance/profit/order',
    method: 'post',
    desc: '月结利润报表-订单明细列表'
  },

  // 月结利润报表-订单总计
  getMonthlyProfitOrderSummary: {
    url: '/finance/profit/order/summary',
    method: 'post',
    desc: '月结利润报表-订单明细总计'
  },

}
